import { Button, Stack, styled } from '@mui/material';

export const WrapperStyled = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isCompact',
})<{ isCompact?: boolean }>(({ theme, isCompact }) => ({
  backgroundColor: theme.palette.neutral[100],
  padding: theme.spacing(1),
  gap: theme.spacing(1),
  flexDirection: 'row',
  borderRadius: theme.spacing(2),
  ...(isCompact && {
    flexDirection: 'column',
  }),
}));

export const ButtonStyled = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'isCompact',
})<{ isActive?: boolean; isCompact?: boolean }>(({ theme, isActive, isCompact }) => ({
  borderRadius: theme.spacing(2),
  backgroundColor: isActive ? theme.palette.primary.main : 'transparent',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: theme.palette.neutral[200],
  },
  '& .MuiTypography-root': {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    fontWeight: 700,
    color: isActive ? theme.palette.neutral.main : theme.palette.secondary[500],
  },
  ...(isCompact && {
    minWidth: 'unset',
    padding: theme.spacing(1),
  }),
}));
